// extracted by mini-css-extract-plugin
export default {"Container":"ForgotPasswordForm_Container__Woa1G"};